export class ColorMapper {
  public static values = [
    { color: 'rgb(102, 0, 13)', opacity: 0.95 },
    { color: 'rgb(165, 15, 21)', opacity: 0.9 },
    { color: 'rgb(203, 25, 29)', opacity: 0.85 },
    { color: 'rgb(239, 59, 44)', opacity: 0.8 },
    { color: 'rgb(251, 106, 74)', opacity: 0.75 },
    { color: 'rgb(252, 146, 114)', opacity: 0.7 },
    { color: 'rgb(252, 187, 161)', opacity: 0.65 },
  ];

  public static assignment(collection: object[]) {
    /**  We're using 7 different colors and opacities. To distribute the same amount of
     * zones for each color we divide the number of zones by the number of colors and, if
     * it isn't int, we round it to the next one
     */
    const polygonsColorQuantity = Math.ceil(collection.length / this.values.length);
    let count = 0;

    collection.forEach((element) => {
      count++;
      let color = '';
      let opacity = 0;

      for (let i = 1; i <= this.values.length; i++) {
        if (count <= polygonsColorQuantity * i) {
          color = this.values[i - 1].color;
          opacity = this.values[i - 1].opacity;
          break;
        }
      }

      element['color'] = color;
      element['opacity'] = opacity;
    });
  }

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/color-mapper.ts